import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import orderCancelImage from "../../assets/icons/dashboard/order_cancelled.png";
import deleveryImage from "../../assets/icons/dashboard/order_delivered.png";
import placeOrderImage from "../../assets/icons/dashboard/order_placed.png";
import shipOrderImage from "../../assets/icons/dashboard/order_shipped.png";

// Image map
const images = {
  placeOrderImage,
  shipOrderImage,
  deleveryImage,
  orderCancelImage,
};

// Status config
const statusItems = [
  {
    status: 0,
    labelKey: "order_place",
    color: "#FF8264",
    imageKey: "placeOrderImage",
  },
  {
    status: 1,
    labelKey: "shipped_Order",
    color: "#7BC4C4",
    imageKey: "shipOrderImage",
  },
  {
    status: 2,
    labelKey: "deliver_Order",
    color: "#7BC4C4",
    imageKey: "deleveryImage",
  },
  {
    status: 9,
    labelKey: "cancel_Order",
    color: "#FF6F61",
    imageKey: "orderCancelImage",
  },
];

const OrderStatusCards = ({ dashboardData }) => {
  const { t } = useTranslation();

  if (!dashboardData) return null;

  return (
    <div className="flex flex-col justify-between">
      {statusItems.map(({ status, labelKey, color, imageKey }) => (
        <div
          key={status}
          className="rounded-lg p-4 dashboard-box border mb-4 bg-white text-sm"
        >
          <Link
            to={`/vendor/orders?status=${status}`}
            className="py-1 flex items-center justify-between"
          >
            <img className="w-6" src={images[imageKey]} alt={labelKey} />
            <div className="flex-grow font-bold text-13 mx-4">
              {t(labelKey)}
            </div>
            <div className="fs-20 fw-600" style={{ color }}>
              {dashboardData?.statuswiseorders?.[status]?.count || 0}
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default OrderStatusCards;
